import React, { ReactNode, useState, useCallback, useEffect } from 'react';
import AblContext from './AblContext';

type Props = {
  children: ReactNode;
}

export default function AblContextProvider(props: Props){
  const { children } = props;
  const [authenticated, setAuthenticated] = useState(false);
  const [roles, setRoles] = useState("");
  const [token, setToken] = useState("");
  const [producer, setProducer] = useState({});

  useEffect(() => {
    const localToken = localStorage.getItem('@authToken')
    if(localToken){
      const token = `bearer ${localStorage.getItem('@authToken')}`
      setToken(token);
    }
  }, [])


  const saveAuthenticated = useCallback((authenticated: boolean) => {
    setAuthenticated(authenticated);
  },[authenticated, setAuthenticated]);

  const saveRoles = useCallback((roles: string) => {
      setRoles(roles);
    }, [roles, setRoles]
  )

  const saveToken = useCallback((token: string) => {
    setToken(token);
  }, [token, setToken])

  const saveProducer = useCallback((producer: object) => {
    setProducer(producer);
  },[producer, setProducer]);

  const value = {
    authenticated,
    roles,
    saveAuthenticated,
    saveRoles,
    token,
    saveToken,
    producer,
    saveProducer,
  }

  return(
    <AblContext.Provider value={value}>
      {children}
    </AblContext.Provider>
  )
}
